import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { capitalize } from 'lodash-es';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EnvironmentEnum } from '../../models/environment-enum';
import { FeatureFlags } from './models';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  readonly featureFlags = signal<FeatureFlags>({ blotterWebsockets: false });

  private httpClient = inject(HttpClient);

  fetchFeatureFlags(): Observable<FeatureFlags> {
    if (environment.name === EnvironmentEnum.Local) {
      this.featureFlags.set({ blotterWebsockets: true });

      return of(this.featureFlags());
    }

    return this.httpClient
      .get<FeatureFlags>('feature-flags', {
        params: { env: capitalize(environment.backendEnv) },
      })
      .pipe(
        tap((flags) => {
          this.featureFlags.set(flags);
        }),
        catchError(() => of(this.featureFlags())),
      );
  }
}
